import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogTitle,
} from "@exopengithub/exokit";
import { DialogActions } from "molecules/dialog/DialogActions";
import { useTranslation } from "react-i18next";
import { ProfilePage } from "./ProfilePage.js";

interface ProfileModalProps {
	open: boolean;
	onClose: () => void;
}

// A modal, not a route: your own profile isn't scoped to whichever company
// you happen to be viewing, but leaving that company's page would drop the
// company sidebar/context. Opening this in place avoids that tradeoff — same
// pattern as "Edit user"/"Edit group" elsewhere in this feature.
export const ProfileModal = ({ open, onClose }: ProfileModalProps) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onClose}>
			<DialogContent size="md">
				<DialogTitle>{t("My profile")}</DialogTitle>
				<DialogBody>{open && <ProfilePage onClose={onClose} />}</DialogBody>
				<DialogActions withCancelButton cancelLabel={t("Close")} />
			</DialogContent>
		</Dialog>
	);
};
